module.exports = __webpack_public_path__ + "img/core_web_vitals_metrics.a55d5dd4.png";